module.exports = __webpack_public_path__ + "static/img/redmud page top img_mobile.5e2b0c6f.jpg";